import { render, staticRenderFns } from "./OrganizationUserRoot.vue?vue&type=template&id=fe653900"
import script from "./OrganizationUserRoot.vue?vue&type=script&lang=ts"
export * from "./OrganizationUserRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports